import React, { FC } from 'react'
import format from 'date-fns/format'
import ja from 'date-fns/locale/ja'
import { CardInner, SettingsScheduleCard, SettingsWarningCard } from 'components/Card'
import { SettingsAccordion, SettingsAccordionItem } from 'components/Accordion'
import { StockType } from 'types/stock'
import { ScheduleType } from 'types/schedule'
import { Spacer } from 'components/Utility'
import { parseToDate } from 'lib/helper'
import { TemporaryOpenDate } from 'types/calendar'

type Props = {
  breadName: string
  expandStatus: string
  imageUrl: string
  resetExpandedStatus: () => void
  dailySchedules: ScheduleType[]
  preorderSchedules: ScheduleType[]
  prevDailySchedules: ScheduleType[]
  prevPreorderSchedules: ScheduleType[]
  stocks: StockType[]
  temporaryOpenDates: TemporaryOpenDate[]
  generatedDailyStocksByDefaultDayOfWeeks: TemporaryOpenDate[]
}

const SettingsConfirmCard: FC<Props> = (props) => {
  const {
    breadName,
    expandStatus,
    imageUrl,
    resetExpandedStatus,
    dailySchedules,
    preorderSchedules,
    prevDailySchedules,
    prevPreorderSchedules,
    stocks,
    temporaryOpenDates,
    generatedDailyStocksByDefaultDayOfWeeks,
  } = props

  return (
    <SettingsAccordion
      breadName={breadName}
      expandStatus={expandStatus}
      imageUrl={imageUrl}
      resetExpandedStatus={resetExpandedStatus}
    >
      <SettingsAccordionItem>
        {prevDailySchedules.length > 0 && (
          <>
            <SettingsScheduleCard
              headline={'受渡解禁時刻とオープン時在庫数'}
              prevSchedules={prevDailySchedules}
              schedules={dailySchedules}
              title={'当日取り置きの設定'}
            />
            <CardInner>
              {generatedDailyStocksByDefaultDayOfWeeks.length > 0 && (
                <>
                  <SettingsWarningCard
                    description={''}
                    content={
                      generatedDailyStocksByDefaultDayOfWeeks
                        .map((generatedDailyStockByDefaultDayOfWeeks) => {
                          return format(generatedDailyStockByDefaultDayOfWeeks.date, 'M月d日（E）', { locale: ja })
                        })
                        .join(', ') + 'は在庫が自動で登録されます。'
                    }
                    title={'在庫が登録されます。'}
                  />
                </>
              )}
              <Spacer size={8} />
            </CardInner>
          </>
        )}
        {prevPreorderSchedules.length > 0 && (
          <>
            <SettingsScheduleCard
              headline={'受渡解禁時刻と販売上限数'}
              prevSchedules={prevPreorderSchedules}
              schedules={preorderSchedules}
              title={'事前予約日の設定'}
            />
            <CardInner>
              {stocks.length > 0 && (
                <>
                  <SettingsWarningCard
                    description={'以下の受渡可能日は削除され、お客さまが購入できなくなります。'}
                    content={stocks
                      .map((stock) => format(parseToDate(stock.date), 'M月d日（E）', { locale: ja }))
                      .join(', ')}
                    title={'削除される受渡可能日'}
                  />
                  <Spacer size={4} />
                </>
              )}
              {temporaryOpenDates.length > 0 && (
                <SettingsWarningCard
                  description={'以下の受渡可能日はお客さまから注文が入っているため、臨時営業日として設定されます。'}
                  content={temporaryOpenDates
                    .map((temporaryOpenDate) => {
                      return format(temporaryOpenDate.date, 'M月d日（E）', { locale: ja })
                    })
                    .join(', ')}
                  subDescription={
                    '※注文のキャンセルを行いたい場合は、sacriサポートセンターにお問い合わせしてください。お問い合わせは'
                  }
                  url={'https://sacrisupport.zendesk.com/hc/ja/requests/new'}
                  title={'臨時営業日として設定される受渡可能日'}
                />
              )}
              <Spacer size={8} />
            </CardInner>
          </>
        )}
      </SettingsAccordionItem>
    </SettingsAccordion>
  )
}

export default SettingsConfirmCard
